import styled from "styled-components";
import tw from "twin.macro";

import { BoxSizingStyle } from "../BoxSizingStyle";
import { FontStyle } from "../FontStyle";
import ArrowLeftIcon from "../Icons/collection/ArrowLeft";
import TreeDotsIcon from "../Icons/collection/TreeDots";

export const StyledMenuSelectorDots = styled(TreeDotsIcon)`
  ${tw`tw-cursor-pointer tw-flex-shrink-0 tw-ml-2`}
`;

StyledMenuSelectorDots.displayName = "StyledMenuSelectorDots";

export const StyledMenuSelectorBack = styled(ArrowLeftIcon)`
  ${tw`tw-cursor-pointer tw-stroke-current tw-flex-shrink-0 tw-mr-2`}
`;

StyledMenuSelectorBack.displayName = "StyledMenuSelectorBack";

export const StyledMenuSelector = styled.div`
  ${BoxSizingStyle}
  ${FontStyle}

  color: var(--color-theme-700);
`;

StyledMenuSelector.displayName = "StyledMenuSelector";

export const StyledMenuSelectorInner = styled.div`
  ${tw`tw-flex tw-items-center tw-m-4`}
`;

StyledMenuSelectorInner.displayName = "StyledMenuSelectorInner";
